module.exports = __webpack_public_path__ + "media/trail/icons-controls-zoom-in-b9e86628.svg";